// importation des bibliothèques de modules node
import React, {useEffect, useState} from 'react';
import {Button, Card, Form} from 'react-bootstrap';
import {useNavigate, useParams} from 'react-router-dom';

// importation du profil layout wrapper
import OldStudentProfileLayout from './OldStudentProfileLayout';

import EleveService from '../../services/EleveService';

const UnarchiveStudent = () => {
    const [student, setStudent] = useState(null);
    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        Promise.all([EleveService.getEleve(id)]).then(([eleveData]) => {
            setStudent(eleveData.data);
        });
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const eleveData = new FormData();

            eleveData.append('archived', false);

            // Call the EleveService to update the student's information
            await EleveService.updateEleve(id, eleveData);

            // Redirect the user to the list of students
            navigate('/education/eleves');
        } catch (error) {
            console.error(
                "Erreur lors de la désarchivage des informations de l'élève",
                error
            );
        }
    };

    return (
        <OldStudentProfileLayout>
            {student && (
                <>
                    {/*  Form  */}
                    <Form className="mb-3" onSubmit={handleSubmit}>
                        <Card className="border-0">
                            <Card.Header>
                                <div className="mb-3 mb-lg-0">
                                    <h3 className="mb-0">
                                        Désarchiver{' '}
                                        <span className="text-uppercase">{student.nom || ''}</span>
                                    </h3>
                                    <p className="mb-0">Réintégrer le profil de cet élève dans la liste.</p>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <span className="text-warning h4">Attention</span>
                                <p>
                                    En désarchivant le profil de cet élève, il réapparaîtra
                                    dans la liste principale des élèves de l'établissement.
                                </p>
                                <Button variant="warning" type="submit">
                                    Désarchiver le profil de l'élève
                                </Button>
                            </Card.Body>
                        </Card>
                    </Form>
                </>
            )}
        </OldStudentProfileLayout>
    );
};

export default UnarchiveStudent;
